import { useState, Children, isValidElement, cloneElement } from 'react';

const StepWizard = ({ className, onCancel, onDone, children }) => {

  const [step, setStep] = useState(0);
  const [value, setValue] = useState(null);
  const [message, setMessage] = useState(null);
  
  const stepCount = Children.toArray(children).length;

  const handleNext = (value, message) => {
    setValue(value);
    setMessage(message);
    if (step === stepCount - 1) {
      return onDone(value, message);
    } else {
      setStep(prev => prev + 1);
    }
  }

  const childrenWithProps = Children.map(children, child =>
    isValidElement(child) ? cloneElement(child, {
      value,
      message,
      onCancel,
      onNext: handleNext,
      onDone,
    }) : child);

  return (
    <div className = {className}>{childrenWithProps[step]}</div>
  )
} 

export default StepWizard;